// packages/web/src/lib/iso-week.ts
function pad2(n: number) {
  return n < 10 ? `0${n}` : String(n);
}

function isoDate(d: Date): string {
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

export function isoWeekFromDate(date: Date): { isoYear: number; isoWeek: number } {
  // Copy and clear time
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d.getTime() - yearStart.getTime()) / 86_400_000 + 1) / 7);
  return { isoYear: d.getUTCFullYear(), isoWeek: weekNo };
}

function isoWeekStartDate(isoYear: number, isoWeek: number): Date {
  const jan4 = new Date(Date.UTC(isoYear, 0, 4));
  const jan4Day = jan4.getUTCDay() || 7;
  const week1Mon = new Date(jan4);
  week1Mon.setUTCDate(jan4.getUTCDate() - (jan4Day - 1));
  const mon = new Date(week1Mon);
  mon.setUTCDate(mon.getUTCDate() + (isoWeek - 1) * 7);
  return mon;
}

export function weekDatesFromIsoYearWeek(isoYear: number, isoWeek: number): string[] {
  const mon = isoWeekStartDate(isoYear, isoWeek);
  const out: string[] = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(mon);
    d.setUTCDate(mon.getUTCDate() + i);
    out.push(isoDate(d));
  }
  return out;
}

function isoWeeksInYear(year: number): number {
  const dec28 = new Date(Date.UTC(year, 11, 28));
  return isoWeekFromDate(dec28).isoWeek;
}

export function prevWeek(isoYear: number, isoWeek: number): { isoYear: number; isoWeek: number } {
  if (isoWeek > 1) return { isoYear, isoWeek: isoWeek - 1 };
  const prevYear = isoYear - 1;
  return { isoYear: prevYear, isoWeek: isoWeeksInYear(prevYear) };
}

export function nextWeek(isoYear: number, isoWeek: number): { isoYear: number; isoWeek: number } {
  if (isoWeek < isoWeeksInYear(isoYear)) return { isoYear, isoWeek: isoWeek + 1 };
  return { isoYear: isoYear + 1, isoWeek: 1 };
}

export function isCurrentWeek(isoYear: number, isoWeek: number, now: Date = new Date()): boolean {
  const cur = isoWeekFromDate(now);
  return cur.isoYear === isoYear && cur.isoWeek === isoWeek;
}
